<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Gerar boleto
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th class="modal-table__header">
                  Id
                </th>
                <td>{{ selectedBill.id }}</td>
              </tr>
              <tr>
                <th class="modal-table__header">
                  Número da parcela
                </th>
                <td>{{ selectedBill.contract_installment }}</td>
              </tr>
              <tr>
                <th class="modal-table__header">
                  Data de vencimento
                </th>
                <td>{{ selectedBill.due_date | formatDate }}</td>
              </tr>
              <tr>
                <th class="modal-table__header">
                  Valor original
                </th>
                <td>{{ selectedBill.amount | formatCurrency }}</td>
              </tr>
              <tr>
                <th class="modal-table__header">
                  Valor atualizado
                </th>
                <td>{{ selectedBill.amount_with_charges | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <div>
              <label for="boleto-date">Data de vencimento</label>
              <date-picker
                v-model="selectedDate"
                id="boleto-date"
                placeholder="Data de vencimento do boleto"
                @dp-change="inputError = null"
                :config="datePickerOptions"
              />
            </div>
            <div>
              <label for="extra-email">E-mail extra para o envio</label>
              <input
                type="email"
                class="form-control"
                id="extra-email"
                v-model="extraEmail"
              >
              <span id="helpBlock" class="help-block">
                O boleto também será enviado para <strong>{{ studentEmail }}</strong>
              </span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="generateBoleto">
            Enviar boleto
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import 'moment/locale/pt-br';
import BillsService from 'services/BillsService';
import DatePicker from 'vue-bootstrap-datetimepicker';
import datePickerOptions from 'utils/DatePickerOptions';

export default {
  props: {
    studentEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDate: moment().startOf('d').format('DD/MM/YYYY'),
      inputError: null,
      newBillValue: null,
      extraEmail: null,
      datePickerOptions,
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
    today() {
      return moment().startOf('d');
    },
  },
  methods: {
    validateSelectedDate() {
      const selectedDueDate = moment(this.selectedDate, 'DD/MM/YYYY');
      if (!selectedDueDate.isValid()) {
        this.inputError = 'A data informada não é válida';
        return false;
      }
      if (selectedDueDate.isAfter(moment().startOf('d').add(15, 'd'))) {
        this.inputError = 'A data de vencimento não pode ser superior a 15 dias';
        return false;
      }
      if (selectedDueDate.isBefore(this.today)) {
        this.inputError = 'A data de vencimento não pode ser anterior a hoje';
        return false;
      }
      return true;
    },
    parseSelectedDate() {
      return moment(this.selectedDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    generateBoleto() {
      if (!this.validateSelectedDate()) return;

      this.$loader.show();
      BillsService.generateBoleto(
        this.selectedBill.id,
        this.parseSelectedDate(),
        this.extraEmail,
      )
        .then((response) => {
          this.$alert.notifySuccess(response.message);
          this.$emit('close');
        })
        .catch(({ response: { data } }) => {
          this.inputError = data.message;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>
